// Default "Import Excel Sheet Name" pre-filled per accordion section on the
// Takeoff Configuration page — sections not listed here start blank.
export const DEFAULT_EXCEL_SHEET_NAMES: Record<string, string> = {
  "Cut & Fill": "PLOT C&F QUANTS",
  Foundations: "PLOT FOUNDS QUANTS",
  Drainage: "PLOT DRAINAGE QUANTS",
  "Plot Drives": "PLOT DRIVES QUANTS",
  "Plot Service": "PLOT SERVICE QUANTS",
  "Plot Paving": "PLOT PAVING QUANTS",
  "Scaffold Platforms": "SCAFFOLD QUANTS",
  Garden: "GARDEN QUANTS",
  "Ret & Screen Walls": "RET & SCREEN TAKE OFF",
  "Geowall & Tobermore Walls": "RET & SCREEN TAKE OFF",
};
